var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3666 3.31374L7.70913 1.34207C7.32413 1.13207 6.85747 1.13207 6.47247 1.34207L2.81497 3.31374C2.54663 3.45957 2.3833 3.73957 2.3833 4.0604C2.3833 4.3754 2.54663 4.66124 2.81497 4.80707L6.47247 6.77874C6.66497 6.88374 6.8808 6.93624 7.0908 6.93624C7.3008 6.93624 7.51663 6.88374 7.70913 6.77874L11.3666 4.80707C11.635 4.66124 11.7983 4.38124 11.7983 4.0604C11.7983 3.73957 11.635 3.45957 11.3666 3.31374Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.87161 7.46051L2.46495 5.75717C2.20245 5.62884 1.89911 5.64051 1.65411 5.79217C1.40328 5.94967 1.25745 6.21217 1.25745 6.50384V9.71801C1.25745 10.2722 1.56661 10.7738 2.06245 11.0247L5.46328 12.728C5.57995 12.7863 5.70828 12.8155 5.83661 12.8155C5.98828 12.8155 6.13995 12.7747 6.27411 12.693C6.52495 12.5413 6.67078 12.273 6.67078 11.9813V8.76717C6.67661 8.20717 6.36745 7.70551 5.87161 7.46051Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5275 5.79258C12.2767 5.64092 11.9734 5.62342 11.7167 5.75758L8.31586 7.46092C7.82003 7.71175 7.51086 8.20758 7.51086 8.76758V11.9817C7.51086 12.2734 7.6567 12.5417 7.90753 12.6934C8.0417 12.7751 8.19336 12.8159 8.34503 12.8159C8.47336 12.8159 8.6017 12.7867 8.71836 12.7284L12.1192 11.0251C12.615 10.7742 12.9242 10.2784 12.9242 9.71842V6.50425C12.9242 6.21258 12.7784 5.95008 12.5275 5.79258Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCube);
export default __webpack_public_path__ + "static/media/cube.d99a9832853f85238569c100f7928636.svg";
export { ForwardRef as ReactComponent };